$(document).on('shopify:section:load', function() {

    if ($('.banner-slider:not(.v2)').length) {
        $('.banner-slider:not(.v2) .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: true,
                smartSpeed: 800,
                autoplay: true,
                autoplayTimeout: 5000,
                margin: 0,
                responsive: {
                    0: {
                        margin: 20
                    },
                    1280: {
                        margin: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                /* let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                } */
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.banner-slider.v2').length) {
        $('.banner-slider.v2 .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: true,
                smartSpeed: 800,
                autoplay: true,
                autoHeight: true,
                autoplayTimeout: 5000,
                margin: 0,
                responsive: {
                    0: {
                        margin: 20
                    },
                    1280: {
                        margin: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                /* let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                } */
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.tabs.product-card').length) {
        $('.tabs .nav-tabs .nav-tab').first().addClass('active');
        $('.tabs .menu-tabs .tab').first().addClass('active').fadeIn(0);

        setTimeout(() => {
            if ($('.tabs .menu-tabs .tab.active').find('.owl-carousel').length) {
                $('.tabs .menu-tabs .tab.active').find('.owl-carousel').each(function () {
                    $(this).trigger('refresh.owl.carousel');
                });
            }
        }, 10);
    
        $('.tabs .nav-tabs .nav-tab').on('click', function () {
            let $this = $(this);
            let tab = $this.data('tab');
    
            $this.siblings().removeClass('active');
            $this.addClass('active');
    
            let $currentTab = $('.tabs .menu-tabs .tab.active');
            let $newTab = $('.tabs .menu-tabs .tab[data-tab="' + tab + '"]');
    
            $currentTab.stop(true, true).fadeOut(300, function () {
                $currentTab.removeClass('active');
                $newTab.stop(true, true).fadeIn(300).addClass('active');

                if ($newTab.find('.owl-carousel').length) {
                    $newTab.find('.owl-carousel').each(function () {
                        $(this).trigger('refresh.owl.carousel');
                    });
                }
            });
        });
    
        $('.tabs.product-card .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3,
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
        });
    }

    if ($('.grid-elements').length) {
        $('.grid-elements .element h5').each(function () {
            let $this = $(this);
            let text = $this.text();
    
            if (/\d+\+/.test(text)) {
                let updatedText = text.replace(/(\d+\+)/g, '<div class="count-it">$1</div>');
                $this.html(updatedText);
    
                let $countElement = $this.find('.count-it');
                let originalNumber = parseInt($countElement.text().match(/\d+/)[0]);
    
                $this.data('countElement', $countElement);
                $this.data('originalNumber', originalNumber);
    
                function randomNumber() {
                    let random1 = Math.floor(Math.random() * originalNumber);
                    let random2 = Math.floor(Math.random() * originalNumber);
    
                    $countElement.html(`
                        <span class="first">${random1}+</span>
                        <span class="second">${random2}+</span>
                        <span class="third">${originalNumber}+</span>
                    `);
                }
    
                function animateNumber() {
                    setTimeout(() => {
                        $countElement.find('.first').css('top', '-50px');
                        $countElement.find('.second').css('top', '0');
                    }, 500);
                    setTimeout(() => {
                        $countElement.find('.second').css('top', '-100%');
                        $countElement.find('.third').css('top', '0');
                    }, 800);
                }
    
                $this.data('randomNumber', randomNumber);
                $this.data('animateNumber', animateNumber);
    
                randomNumber();
                animateNumber();
            }
        });
    }

    if ($('.personal-reviews').length) {
        $('.personal-reviews .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 4,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 40
                    },
                    428: {
                        items: 1,
                        stagePadding: 50
                    },
                    768: {
                        items: 2,
                        stagePadding: 80
                    },
                    1280: {
                        items: 4,
                        stagePadding: 0
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.brand-reviews').length) {
        $('.brand-reviews').each(function() {
            let $carousel = $(this).find('.owl-carousel');
        
            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: true,
                autoHeight: true,
                smartSpeed: 800,
                responsive: {
                    0: {
                        margin: 30
                    },
                    1280: {
                        margin: 0
                    }
                }
            });

        });
    }

    if ($('.blog-posts').length) {
        $('.blog-posts').each(function () {
            let el = $(this);

            el.find('.articles').on('scroll', function () {
                let container = $(this);

                container.find('.article').each(function () {
                    let article = $(this);

                    let containerTop = container.offset().top;
                    let articleTop = article.offset().top - containerTop;
        
                    console.log(articleTop);

                    if (articleTop <= 100) 
                        article.addClass('active');
                    else 
                        article.removeClass('active');
                    
                });
            });

            el.find('.articles').each(function () {
                let container = $(this);
                let isDragging = false;
                let startY, scrollTop;

                container.css('cursor', 'grab');
        
                container.on('mousedown', function (e) {
                    isDragging = true;
                    startY = e.pageY - container.offset().top;
                    scrollTop = container.scrollTop();

                    container.css('cursor', 'grabbing');
                });
        
                container.on('mouseleave', function () {
                    if (!isDragging) {
                        container.css('cursor', 'grab');
                    }
                });
        
                container.on('mouseup', function () {
                    isDragging = false;
                    container.css('cursor', 'grab');
                });
        
                container.on('mousemove', function (e) {
                    if (!isDragging) return;
        
                    e.preventDefault();
                    let y = e.pageY - container.offset().top;
                    let walk = (y - startY) * 2;
                    container.scrollTop(scrollTop - walk);
                });
            });
        });

        $('.blog-posts .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 50,
                responsive: {
                    0: {
                        stagePadding: 30
                    },
                    390: {
                        stagePadding: 30
                    },
                    414: {
                        stagePadding: 40
                    },
                    428: {
                        stagePadding: 50
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }
    
    if ($('.grid-gallery').length) {
        $('.grid-gallery .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 80,
                responsive: {
                    0: {
                        stagePadding: 40
                    },
                    390: {
                        stagePadding: 60
                    },
                    414: {
                        stagePadding: 70
                    },
                    428: {
                        stagePadding: 80
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }

    banner_slider();
    text_image_float();
    grid_elements();
    freesky_mask();
    vertical_slider();
    grid_gallery();
    inner_banner();
});

$(document).ready(function() {

    if ($('.banner-slider:not(.v2)').length) {
        $('.banner-slider:not(.v2) .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                margin: 0,
                responsive: {
                    0: {
                        margin: 20
                    },
                    1280: {
                        margin: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                /* let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                } */
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.banner-slider.v2').length) {
        $('.banner-slider.v2 .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                loop: true,
                autoplay: true,
                autoHeight: true,
                autoplayTimeout: 5000,
                margin: 0,
                responsive: {
                    0: {
                        margin: 20
                    },
                    1280: {
                        margin: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                /* let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                } */
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.tabs.product-card').length) {
        $('.tabs .nav-tabs .nav-tab').first().addClass('active');
        $('.tabs .menu-tabs .tab').first().addClass('active').fadeIn(0);

        setTimeout(() => {
            if ($('.tabs .menu-tabs .tab.active').find('.owl-carousel').length) {
                $('.tabs .menu-tabs .tab.active').find('.owl-carousel').each(function () {
                    $(this).trigger('refresh.owl.carousel');
                });
            }
        }, 10);
    
        $('.tabs .nav-tabs .nav-tab').on('click', function () {
            let $this = $(this);
            let tab = $this.data('tab');
    
            $this.siblings().removeClass('active');
            $this.addClass('active');
    
            let $currentTab = $('.tabs .menu-tabs .tab.active');
            let $newTab = $('.tabs .menu-tabs .tab[data-tab="' + tab + '"]');
    
            $currentTab.stop(true, true).fadeOut(300, function () {
                $currentTab.removeClass('active');
                $newTab.stop(true, true).fadeIn(300).addClass('active');

                if ($newTab.find('.owl-carousel').length) {
                    $newTab.find('.owl-carousel').each(function () {
                        $(this).trigger('refresh.owl.carousel');
                    });
                }
            });
        });
    
        $('.tabs.product-card .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3,
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
        });
    }

    if ($('.grid-elements').length) {
        $('.grid-elements .element h5').each(function () {
            let $this = $(this);
            let text = $this.text();
    
            if (/\d+\+/.test(text)) {
                let updatedText = text.replace(/(\d+\+)/g, '<div class="count-it">$1</div>');
                $this.html(updatedText);
    
                let $countElement = $this.find('.count-it');
                let originalNumber = parseInt($countElement.text().match(/\d+/)[0]);
    
                $this.data('countElement', $countElement);
                $this.data('originalNumber', originalNumber);
    
                function randomNumber() {
                    let random1 = Math.floor(Math.random() * originalNumber);
                    let random2 = Math.floor(Math.random() * originalNumber);
    
                    $countElement.html(`
                        <span class="first">${random1}+</span>
                        <span class="second">${random2}+</span>
                        <span class="third">${originalNumber}+</span>
                    `);
                }
    
                function animateNumber() {
                    setTimeout(() => {
                        $countElement.find('.first').css('top', '-50px');
                        $countElement.find('.second').css('top', '0');
                    }, 500);
                    setTimeout(() => {
                        $countElement.find('.second').css('top', '-100%');
                        $countElement.find('.third').css('top', '0');
                    }, 800);
                }
    
                $this.data('randomNumber', randomNumber);
                $this.data('animateNumber', animateNumber);
    
                randomNumber();
                animateNumber();
            }
        });
    }

    if ($('.personal-reviews').length) {
        $('.personal-reviews .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 4,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 40
                    },
                    428: {
                        items: 1,
                        stagePadding: 50
                    },
                    768: {
                        items: 2,
                        stagePadding: 80
                    },
                    1280: {
                        items: 4,
                        stagePadding: 0
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.brand-reviews').length) {
        $('.brand-reviews').each(function() {
            let $carousel = $(this).find('.owl-carousel');
        
            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: true,
                autoHeight: true,
                smartSpeed: 800,
                responsive: {
                    0: {
                        margin: 30
                    },
                    1280: {
                        margin: 0
                    }
                }
            });

        });
    }

    if ($('.blog-posts').length) {
        $('.blog-posts').each(function () {
            let el = $(this);

            el.find('.articles').on('scroll', function () {
                let container = $(this);

                container.find('.article').each(function () {
                    let article = $(this);

                    let containerTop = container.offset().top;
                    let articleTop = article.offset().top - containerTop;
        
                    console.log(articleTop);

                    if (articleTop <= 100) 
                        article.addClass('active');
                    else 
                        article.removeClass('active');
                    
                });
            });

            el.find('.articles').each(function () {
                let container = $(this);
                let isDragging = false;
                let startY, scrollTop;

                container.css('cursor', 'grab');
        
                container.on('mousedown', function (e) {
                    isDragging = true;
                    startY = e.pageY - container.offset().top;
                    scrollTop = container.scrollTop();

                    container.css('cursor', 'grabbing');
                });
        
                container.on('mouseleave', function () {
                    if (!isDragging) {
                        container.css('cursor', 'grab');
                    }
                });
        
                container.on('mouseup', function () {
                    isDragging = false;
                    container.css('cursor', 'grab');
                });
        
                container.on('mousemove', function (e) {
                    if (!isDragging) return;
        
                    e.preventDefault();
                    let y = e.pageY - container.offset().top;
                    let walk = (y - startY) * 2;
                    container.scrollTop(scrollTop - walk);
                });
            });
        });

        $('.blog-posts .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 50,
                responsive: {
                    0: {
                        stagePadding: 30
                    },
                    390: {
                        stagePadding: 30
                    },
                    414: {
                        stagePadding: 40
                    },
                    428: {
                        stagePadding: 50
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }
    
    if ($('.grid-gallery').length) {
        $('.grid-gallery .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 80,
                responsive: {
                    0: {
                        stagePadding: 40
                    },
                    390: {
                        stagePadding: 60
                    },
                    414: {
                        stagePadding: 70
                    },
                    428: {
                        stagePadding: 80
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }

    banner_slider();
    text_image_float();
    grid_elements();
    freesky_mask();
    vertical_slider();
    grid_gallery();
    inner_banner();
});

$(window).on('scroll', function() {
    text_image_float();
    grid_elements();
    freesky_mask();
    vertical_slider();
    grid_gallery();
    inner_banner();
});

$(window).on('resize', function() {
    banner_slider();
});

function banner_slider() {
    if ($('.banner-slider:not(.v2)').length) {
        let headerH = $('.header').height();

        if (wSize < 1280) {
            $('.banner-slider:not(.v2)').css('height', `${hSize - headerH}px`);
        }
    }
}

function text_image_float() {
    if ($('.text-image-float').length) {
        $('.text-image-float').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 50) {
                el.find('.aos-init').addClass('aos-animate');
                el.find('img').addClass('active');
            } else {
                el.find('.aos-init').removeClass('aos-animate');
                el.find('img').removeClass('active');
            }
        });    
    }
}

function grid_elements() {
    if ($('.grid-elements').length) {
        $('.grid-elements').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');

                el.find('.element h5').each(function () {
                    let $this = $(this);
                    if (!$this.data('hasAnimated') && $this.data('randomNumber') && $this.data('animateNumber')) {
                        $this.data('randomNumber')();
                        $this.data('animateNumber')();
                        $this.data('hasAnimated', true);
                    }
                });

            } else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}

function freesky_mask() {
    if ($('.freesky-mask').length) {
        $('.freesky-mask').each(function() {
            let el = $(this);
            let video = $(this).find('video').get(0);

            let scrolled = visiblePercent(el) * 2;
            let mask = Math.min(Math.max(scrolled - 100, 0), 50);

            if (scrolled >= 90) {
                let scale = 100 + (mask*5);
                let opacity = 1 - ((mask*2)/100);

                $('.freesky-mask .sticky .mask').css({
                    'background-size': `${scale}%`,
                    'opacity': `${opacity}`
                });

                $('.freesky-mask .sticky .mask-m').css({
                    'background-size': `${scale}%`,
                    'opacity': `${opacity}`
                });
            }

            if (scrolled >= 150) {
                video.play();
                el.find('.aos-init').addClass('aos-animate');
            } 
            else {
                video.pause();
                video.currentTime = 0;
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}

function vertical_slider() {
    $('.vertical-slider:not(.two)').each(function () {
        let el = $(this);

        let $images = $(this).find('.wrapper .image-container');
        let $toggles = $(this).find('.wrapper .toggles');
        let $data = $(this).find('.wrapper .data-container');

        if ($(this).find('.wrapper').data('size') == 1) {
            $(this).find('.wrapper').css('height', '100vh');
        }
        if ($(this).find('.wrapper').data('size') == 2) {
            $(this).find('.wrapper').css('height', '160vh');

            let scrolled = visiblePercent(el) * 1.6;

            if (scrolled >= 120) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '5%',
                    'right': '5%',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });

                $toggles.find('.toggle:nth-child(2)').addClass('active').siblings().removeClass('active');

                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '0',
                    'opacity': '1'
                });
            }
            else {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });

                $toggles.find('.toggle:nth-child(1)').addClass('active').siblings().removeClass('active');

                $data.find('.data:nth-child(1)').css({
                    'top': '0',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
        }
        if ($(this).find('.wrapper').data('size') == 3) {
            $(this).find('.wrapper').css('height', '200vh');

            let scrolled = visiblePercent(el) * 2;

            if (scrolled >= 120 && scrolled < 160) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '5%',
                    'right': '5%',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });

                $toggles.find('.toggle:nth-child(2)').addClass('active').siblings().removeClass('active');

                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '0',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
            else if (scrolled >= 160) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '10%',
                    'right': '10%',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '5%',
                    'right': '5%',
                    'opacity': '1'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });

                $toggles.find('.toggle:nth-child(3)').addClass('active').siblings().removeClass('active');
                
                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '0',
                    'opacity': '1'
                });
            }
            else {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });
                
                $toggles.find('.toggle:nth-child(1)').addClass('active').siblings().removeClass('active');
            
                $data.find('.data:nth-child(1)').css({
                    'top': '0',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
        }
    });
}

function grid_gallery() {
    if ($('.grid-gallery').length) {
        $('.grid-gallery').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.grid-row > *:nth-child(odd)').css('top', '0');

            } else {
                el.find('.grid-row > *:nth-child(odd)').css('top', '80px');
            }
        });
    }
}

$('.two-image-hover .image-wrapper').on('mouseover', function() {
    if (wSize >= 1280) {
        $('.two-image-hover .image-wrapper').css('width', '45%');
        $(this).css('width', '55%');
    }
}).on('mouseleave', function() {
    if (wSize >= 1280) {
        $('.two-image-hover .image-wrapper').css('width', '50%');
    }
});

function inner_banner() {
    if ($('.inner-banner').length) {
        $('.inner-banner').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
            } else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}

$('.banner-slider.v2 .item').on('click', function() {
    let url = $(this).data('url');
    window.location.href = url;
});